// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StarOutlineGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 24.1c.099 0 .198.022.29.066l6.639 3.209-.856-7.68a.669.669 0 0 1 .16-.514l5.014-5.714-7.222-1.52a.668.668 0 0 1-.45-.338L16 4.915l-3.575 6.694a.666.666 0 0 1-.451.338l-7.221 1.52 5.012 5.714a.669.669 0 0 1 .162.514l-.857 7.68 6.64-3.209A.664.664 0 0 1 16 24.1Zm7.725 5.066a.665.665 0 0 1-.29-.066L16 25.507 8.564 29.1a.667.667 0 0 1-.952-.674l.957-8.586-5.57-6.351a.666.666 0 0 1 .363-1.092l8.033-1.69 4.017-7.52a.666.666 0 0 1 1.176-.001l4.016 7.52 8.033 1.69a.667.667 0 0 1 .364 1.093l-5.57 6.35.957 8.587a.667.667 0 0 1-.663.74Z"
			fill="url(#StarOutlineGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="StarOutlineGradient_tsx__a"
				x1={2.833}
				y1={2.833}
				x2={29.166}
				y2={29.167}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F094" />
				<stop offset={1} stopColor="#75B2F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default StarOutlineGradient;
